export default __webpack_public_path__ + "media/avatars/default-a52fdb03.png";